import { gql } from 'apollo-boost';

export const LOGOUT_MUTATION = gql`
mutation logOut($token: String!) {
    logOut(token: $token) {
        loggedOut
        errors
    }
}
`;